//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'Dialog',
  props: {
    title: String,
    showFooter: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      isOpen: false
    }
  },
  watch: {
    isOpen() {
      if (!this.isOpen) {
        this.$emit('close')
      }
    }
  },
  created() {
    this.isOpen = true
  }
}
